var React = require('react');

function De (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#ffda44","d":"M0 345l256.7-25.5L512 345v167H0z","key":0}),React.createElement("path",{"fill":"#d80027","d":"M0 167l255-23 257 23v178H0z","key":1}),React.createElement("path",{"fill":"#333","d":"M0 0h512v167H0z","key":2})])]);
}

De.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = De;

De.default = De;
